import { actions } from '../../actions';

/**
 * This list of messages for handling failure notifications
 *
 */
export const messages = {
  [actions.cartFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [actions.lastCartFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [actions.cartCurrentDeliveryFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [actions.itemAddFetch.failure.type]:
    'Este item não está disponível no momento. Tente adicionar outro produto.',
  [actions.itemUpdateFetch.failure.type]: 'Não conseguimos atualizar este produto.',
  [actions.itemDeleteFetch.failure.type]: 'Não conseguimos remover este produto.',
};
